import React from 'react';
import { gridConnectionsIndexRoute } from '@/modules/charge-center/grid-connections/index/route';
import { createRoute } from '@tanstack/react-router';

// ! I think this will use the old connectors table, also Index route as a temporary fix for the Outlet not being correct
export const connectorsRoute = createRoute({
  getParentRoute: () => gridConnectionsIndexRoute,
  path: 'connectors',
  component: React.lazy(async () => await import('@/app/routes/ChargeCenter/ConnectorTab')),
  wrapInSuspense: true,
});
